import customerApi from 'api/customer';
import CustomerTable from './results';
import events from 'lib/events';
import Header from 'components/layout/header';
import hopscotch from 'hopscotch';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import PageFooter from 'components/layout/pageFooter';
import Pagination from 'components/layout/pagination';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SearchField from 'components/searchField';
import sessionService from 'services/sessionService';
import {dealerAdminTourFormat, storeAdminTourFormat} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import dealerApi from 'api/dealer';
import Dealer from 'models/dealer';
import session from 'services/sessionService';

const addCustomerLink = '#/customer/add';

// Register in router

let render = (container, params) => {
  console.info('[UI.page.customers] rendering page');
  ReactDOM.render(
    <IntlWrapper>
      <WrappedCustomers page={params.page} filter={params.search} />
    </IntlWrapper>,
    container);
  events.publish('page-change', {page: 'customers'});
};

console.info('[UI.page.customers] register route');
router.rr.add([{path: '', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'customers', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'customers/:search', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'customers/:search/:page', handler: routeUtils.requireAuth(render)}]);

// Page object
class Customers extends React.Component {
  static displayName = 'CustomerSearch';

  static propTypes = {
    filter: PropTypes.string,
    intl: intlShape.isRequired,
    page: PropTypes.number,
  };

  state = {
    loaded: false,
    hasSearched: false,
    filter: '',
    customers: [],
    count: 0,
    total: 0,
    page: 1,
    user: session.getUser(),
    dealer: new Dealer({}),
  };

  componentWillMount() {
    let apis = [];

    apis.push(dealerApi.getDealer(this.state.user.dealerId));

    if (this.props.filter) {
      let filter = this.props.filter === '<empty>' || !this.props.filter ? '' : this.props.filter;

      if (filter.indexOf('duplicates-') === 0) {
        apis.push(customerApi.getCustomerDuplicates(filter));
        Promise.all(apis)
        .then(([dealer, customers]) => {
          this.setState({
            loaded: true,
            customers: customers,
            count: customers.length,
            dealer: dealer,
            total: customers.length,
            page: 1,
          });
        });
      }else{
        apis.push(customerApi.getCustomers(filter, this.props.page));
        Promise.all(apis)
        .then(([dealer, customers]) => {
          this.setState({
            loaded: true,
            customers: customers.rows,
            count: customers.count,
            dealer: dealer,
            total: customers.total,
            page: customers.page,
          });
        });
      }
    } else {
      Promise.all(apis)
      .then(([dealer]) => {
        this.setState({
          loaded: true,
          dealer: dealer,
        });
      });
    }
  }

  componentDidMount() {
    var ua = window.navigator.userAgent;

    let satf = storeAdminTourFormat(this.props.intl.formatMessage);
    let datf = dealerAdminTourFormat(this.props.intl.formatMessage);

    if (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') !== -1) {
      datf.steps[0].yOffset = -163;
      datf.steps[2].yOffset = -31;
      datf.steps[3].yOffset = -31;
      satf.steps[0].yOffset = -140;
      satf.steps[2].yOffset = -30;
    }
    if (hopscotch.getState() === 'dealerAdmin:2') {
      hopscotch.startTour(datf, 2);
    } else {
      if (window.location.hash.indexOf('tour') !== -1) {
        if (sessionService.getUser().privileges.level >= 3000) {
          hopscotch.startTour(datf);
        } else {
          hopscotch.startTour(satf);
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.page !== this.state.page || nextProps.filter !== this.state.filter) {
      let filter = nextProps.filter === '<empty>' || !nextProps.filter ? '' : nextProps.filter;

      console.log(this.state.dealer);
      customerApi.getCustomers(filter, nextProps.page)
        .then(customers => this.setState({
          loaded: true,
          customers: customers.rows,
          count: customers.count,
          total: customers.total,
          page: customers.page,
        }));
    }
  }

  componentWillUnmount() {
    if (hopscotch.isActive && window.location.hash !== '#settings') {
      hopscotch.endTour();
    }
  }

  getPostSearchInput = () => {
    let filter = this.props.filter !== '<empty>' ? this.props.filter : '';

    if (this.props.filter && this.props.filter.indexOf('duplicates-') === 0) {
      filter = '';
    }
    return (
      <div className='row has-searched' style={{marginTop: 15, marginBottom: 40}}>
        <div className='col-sm-6'>
          <SearchField placeholder={this.props.intl.formatMessage({id: 'customer.search.placeholder'})} initialValue={decodeURIComponent(filter)} key='search-field'
                       onSearch={this.filterChange} debounceDelay={1000} />
        </div>
      </div>
    );
  };

  getPreSearchInput = () => {
    let filter = this.props.filter !== '<empty>' ? this.props.filter : '';

    if (this.props.filter && this.props.filter.indexOf('duplicates-') === 0) {
      filter = '';
    }
    return <div className='search-customers'>
      <h3><FormattedMessage id="customer.search.find" /></h3>
      <div>
        <SearchField placeholder={this.props.intl.formatMessage({id: 'customer.search.placeholder'})} autoFocus key='search-field'
          initialValue={filter} onSearch={this.filterChange} debounceDelay={1000} />
      </div>
      <div className='horizontal-line'><span className='super-impose'>{this.props.intl.formatMessage({id: 'connector.or'}).toUpperCase()}</span></div>
      <a className='btn btn-primary' href={addCustomerLink}>
        <i className='bl bl-add pull-left' /> <FormattedMessage id="customer.search.new" />
      </a>
    </div>;
  };

  filterChange = (e) => {
    let filter = e === '' ? '<empty>' : e;

    window.location.replace('#/customers/' + encodeURIComponent(filter));
  };

  validateUnexistingPage = () => {
    if(this.state.total === 0 && this.state.page > 1) {
      this.setState({page: 1});
    }
  };

  render() {
    this.validateUnexistingPage();

    let hasSearched = !!this.props.filter;

    let input;

    if (hasSearched) {
      input = this.getPostSearchInput();
    } else {
      input = this.getPreSearchInput();
    }

    let contactIDs = [];

    if (this.props.filter && this.props.filter.indexOf('duplicates-', '') === 0) {
      contactIDs = this.props.filter.replace('duplicates-', '')
        .split(',')
        .map(x => {
          let ids = x.split('-');

          return ids.length === 2 ? parseInt(x.split('-')[1]) : null;
        });
    }
    return (
      <div id='page-customers' className='container'>
        <Header mainTitle={this.props.intl.formatMessage({id: 'customer.analysis.title'})}
          mainTitleReturn={hasSearched ? 'customers' : ''}
          subTitle={hasSearched ? this.props.intl.formatMessage({id: 'general.search.results'}) : null}>
          {hasSearched ?
            <div className='add-new-customer pull-right'>
              <a className='btn btn-primary' href={addCustomerLink}>
                <i className='bl bl-add pull-left' /> <FormattedMessage id="customer.search.new" />
              </a>
            </div> :
          null }
        </Header>
        {input}
        {hasSearched ?
          <div>
            <Loader loaded={this.state.loaded}>
              <div className='search-results-container'>
                <CustomerTable customers={this.state.customers} contactIDs={contactIDs} dealer={this.state.dealer}/>
              </div>
            </Loader>
            <PageFooter className='tc'>
              <Pagination
                baseUrl={'customers/' + encodeURIComponent(this.props.filter) + '/'}
                page={this.state.page}
                count={this.state.count}
                total={this.state.total} />
            </PageFooter>
          </div>          :
          null
        }
      </div>
    );
  }
}

let WrappedCustomers = injectIntl(Customers);

export default WrappedCustomers;
